import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ConnectorDialog } from '../dialog';
import '../../../styles/connectorSetting.scss';

export class ConnectorSetting extends Component {
  state = { open: false };

toggleOpen=(data) => {
  const { open } = this.state;
  const { getConnectorSettings } = this.props;
  if (open && data) {
    getConnectorSettings(data);
  }
  this.setState((state) => {
    const { open } = state;
    return { open: !open };
  });
}

render() {
  const { open } = this.state;
  const { connectorSettings } = this.props;
  const { connectorType = 'solid', color = 'black', size = '5' } = connectorSettings;
  const border = `${`${size}px`} ${connectorType} ${color}`;
  return (
    <div className="connector-setting">
      <div onClick={this.toggleOpen}> Connectors </div>
      <div className="connector" style={{ border }} onClick={this.toggleOpen} />
      {open && (
        <ConnectorDialog
          open={open}
          close={this.toggleOpen}
          connectorSettings={connectorSettings}
        />
      )}

    </div>
  );
}
}

ConnectorSetting.propTypes = {
  getConnectorSettings: PropTypes.func.isRequired,
  connectorSettings: PropTypes.instanceOf(Object).isRequired,
};
